export const setFormData = (e) => {

    return function (dispatch) {

        dispatch({
            type: 'FORM_DATA',
            payload: {
                'Name': e.target.name,
                'Value': e.target.value,
            }
        })
        
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/setFormData.js